import { get, writable } from 'svelte/store';

const STORAGE_KEY = 'shelly_dev_verivox_force_enable';

const readInitialValue = (): boolean => {
	try {
		return localStorage.getItem(STORAGE_KEY) === 'true';
	} catch {
		return false;
	}
};

/** When true, Verivox UIs are force-enabled for QA regardless of de_users. */
export const verivoxDevForceEnable = writable<boolean>(readInitialValue());

verivoxDevForceEnable.subscribe((value) => {
	try {
		localStorage.setItem(STORAGE_KEY, String(value));
	} catch {
		// localStorage may be unavailable
	}
});

export const isVerivoxDevForceEnabled = (): boolean => get(verivoxDevForceEnable);

export const setVerivoxDevForceEnable = (enabled: boolean) => {
	verivoxDevForceEnable.set(enabled);
};
